import { CounterContext } from "./CounterContext";

export default CounterContext;
